import { BetaDataTableCell as Cell, Spacer, Tag } from "@zapier/design-system";
import { TooltipText } from "@zapier/shared";

import styles from "./AppTagCell.module.css";
import { ComponentProps } from "react";

interface ImplementationBadge {
  label: string;
  color: string;
  tooltip_markdown?: string;
}

interface AppTagCellProps {
  badges?: ImplementationBadge[];
}

type TagVariant = ComponentProps<typeof Tag>["variant"];

const AppTagCell = ({ badges }: AppTagCellProps) => {
  return (
    <Cell>
      {badges && badges.length > 0 ? (
        <span className={styles.root}>
          <TooltipText
            id={`app-tags-${badges.map((badge) => badge.label!).join("-")}`}
            label={badges.map((badge) => badge.label!).join(", ")}
            placement="bottom"
          >
            <span className={styles.badgesOverflow}>
              <span className={styles.badges}>
                {badges.map((badge) => (
                  <Tag
                    key={badge.label!}
                    variant={badge.color! as unknown as TagVariant}
                  >
                    {badge.label!}
                  </Tag>
                ))}
              </span>
            </span>
          </TooltipText>
        </span>
      ) : (
        <Spacer width={88} />
      )}
    </Cell>
  );
};

export default AppTagCell;
